export default "__VITE_ASSET__BaPgNypd__"